

import { SectionCard } from "./SectionCard";
import { ExpenseRow, fmt, fmtDate } from "./types";

interface ExpensesSectionProps {
  expenses: ExpenseRow[];
}

export function ExpensesSection({ expenses }: ExpensesSectionProps) {
  const totalAmount = expenses.reduce((s, e) => s + e.amount, 0);

  return (
    <SectionCard
      title="Additional Expenses"
      icon={
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
      }
    >
      {expenses.length === 0 ? (
        <p className="text-xs text-stone-400 italic">No additional expenses recorded.</p>
      ) : (
        <div className="overflow-x-auto -mx-4 sm:mx-0">
          <div className="min-w-[450px] px-4 sm:px-0">
            <div className="rounded-xl border border-stone-100 overflow-hidden">
              <table className="w-full text-xs">
                <thead className="bg-stone-50">
                  <tr>
                    {["Title", "Category", "Date", "Paid To", "Amount"].map((h) => (
                      <th key={h} className={`px-3 py-2.5 text-stone-500 font-semibold uppercase whitespace-nowrap ${h === "Amount" ? "text-right" : "text-left"}`}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-stone-50">
                  {expenses.map((e, i) => (
                    <tr key={i} className="hover:bg-stone-50/50">
                      <td className="px-3 py-2.5 font-medium text-stone-800 max-w-[150px] truncate">{e.title}</td>
                      <td className="px-3 py-2.5 text-stone-500">{e.category}</td>
                      <td className="px-3 py-2.5 text-stone-500 whitespace-nowrap">{fmtDate(e.expense_date)}</td>
                      <td className="px-3 py-2.5 text-stone-500 max-w-[100px] truncate">{e.paid_to ?? "-"}</td>
                      <td className="px-3 py-2.5 text-right font-semibold text-stone-700">{fmt(e.amount)}</td>
                    </tr>
                  ))}
                  <tr className="border-t-2 border-stone-200 bg-stone-50 font-semibold">
                    <td className="px-3 py-2.5 text-stone-700" colSpan={4}>Total</td>
                    <td className="px-3 py-2.5 text-right text-stone-800">{fmt(totalAmount)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </SectionCard>
  );
}
